module.exports = __webpack_public_path__ + "static/media/two-polar-bears-background-Recovered.b3cc2f43.jpg";